import { render, staticRenderFns } from "./Post3952.vue?vue&type=template&id=4c5fb01f"
import script from "./Post3952.vue?vue&type=script&lang=js"
export * from "./Post3952.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports